module.exports = __webpack_public_path__ + "static/img/shujubanner.195ad57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shujubanner.png
// module id = y74j
// module chunks = 1